import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SecurityRoutingStates } from '../../modules/security/security-routing.module';
import { AuthService } from '../../modules/security/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.authService.isAuthenticated()) {
      console.error('User not authenticated, redirecting to login');
      this.router.navigate([
        `/console/${SecurityRoutingStates.LOGIN_STATE.url}`
      ]);
      return false;
    }
    if (!this.authService.isValidUser()) {
      console.error(
        'No valid user group or groups, redirecting to unauthorized'
      );
      this.router.navigate([`${SecurityRoutingStates.UNAUTHORIZED_STATE}`]);
      return false;
    }
    let groups: Array<string> = next.data['requiresRole']
      ? next.data['requiresRole']
      : [];
    if (!this.validateRoleAccess(groups)) {
      console.error('Restricted access, redirecting to unauthorized');
      this.router.navigate([`${SecurityRoutingStates.UNAUTHORIZED_STATE}`]);
    }
    return true;
  }

  /**
   * Checks for current user groups to validate access.
   * @param {Array<string>} groups
   * @returns {boolean}
   */
  private validateRoleAccess(groups: Array<string>): boolean {
    if (groups.length === 0) {
      return true;
    }
    let allowAccess = 0;
    groups.forEach(group => {
      if (this.authService.userHasGroup(group)) {
        allowAccess++;
      }
    });
    return allowAccess > 0;
  }
}
